import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "trapimageplacementtypes"
    }}>{`TrapImagePlacementTypes`}</h1>
    <p>{`Options for trap placement between vector objects and bitmap images.`}</p>
    <h2 {...{
      "id": "class"
    }}>{`Class`}</h2>
    <blockquote>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`CENTER_EDGES`}</strong>{` = 1953522542`}</p>
      <p parentName="blockquote">{`Creates a trap that straddles the edge between vector objects and bitmap images.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`CHOKE`}</strong>{` = 1953522536`}</p>
      <p parentName="blockquote">{`Causes vector objects to overlap abutting images.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`IMAGE_NEUTRAL_DENSITY`}</strong>{` = 1953525348`}</p>
      <p parentName="blockquote">{`Applies the same trapping rules as used elsewhere in the document. Note: When used to trap an object to a photograph, can result in noticeably uneven edges as the trap moves from one side of the edge to another.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`IMAGES_OVER_SPREAD`}</strong>{` = 1953526640`}</p>
      <p parentName="blockquote">{`Causes bitmap images to overlap the abutting objects.`}</p>
    </blockquote>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      